<p-card styleClass="ranking-card">
    <div class="header-row" style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 1rem">
        <h2 style="margin: 0">Target-wise Sales Person Ranking</h2>

        <div class="filters" style="display: flex; align-items: center; gap: 1rem">
            <p-selectButton [options]="dateViewOptions" [(ngModel)]="selectedView" (onChange)="onDateViewChange()" optionLabel="label" optionValue="value"></p-selectButton>

            <!-- Only show date range calendars when Custom selected -->
            <ng-container *ngIf="selectedView === 'custom'">
                <input id="fromDate" pInputText [(ngModel)]="fromDate" name="fromDate" type="date" class="p-inputtext p-component" style="width: 160px" (change)="onDateChange()" [max]="toDate" required />
                <span>to</span>
                <input id="toDate" pInputText [(ngModel)]="toDate" name="toDate" type="date" class="p-inputtext p-component" style="width: 160px" (change)="onDateChange()" [min]="fromDate" required />
            </ng-container>
        </div>
    </div>
    <div *ngIf="!loading">
        <p-table
            [value]="rankingData"
            [paginator]="true"
            [rows]="10"
            [rowsPerPageOptions]="[10, 20, 30, 50]"
            scrollable="true"
            scrollHeight="400px"
            [showCurrentPageReport]="true"
            responsiveLayout="scroll"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
            [tableStyle]="{ 'min-width': '50rem' }"
        >
            <ng-template pTemplate="header">
                <tr>
                    <th>Rank</th>
                    <th>Sales Person</th>
                    <th>Target</th>
                    <th>Net Amount</th>
                    <th>VAT Amount</th>
                    <th>Net + VAT</th>
                    <th>Achievement </th>
                    <th>Orders Punched</th>
                    <th>Start Date</th>
                    <th>End Date</th>
                    <th>Progress</th>
                    <th>Status</th>
                </tr>
            </ng-template>

            <ng-template pTemplate="body" let-person let-rowIndex="rowIndex">
                <tr>
                    <td>
                        <div class="rank-badge" [ngClass]="getRankClass(rowIndex)">
                            {{ rowIndex + 1 }}
                        </div>
                    </td>
                    <td>
                        <div class="person-info">
                            <div class="person-avatar">
                                <i class="pi pi-user"></i>
                            </div>
                            <span class="person-name">{{ person.username }}</span>
                        </div>
                    </td>
                    <td>{{ person.target | currency: 'EUR' }}</td>
                    <td>{{ person.netAmount | currency: 'EUR' }}</td>
                    <td>{{ person.vatAmount | currency: 'EUR' }}</td>
                    <td>{{ (person.netAmount || 0) + (person.vatAmount || 0) | currency: 'EUR' }}</td>
                    <td>{{ (person.orderLineAmount ?? person.achievement) | currency: 'EUR' }}</td>
                    <td>{{ person.ordersPunched }}</td>
                    <td>{{ person.startDate | date: 'shortDate' }}</td>
                    <td>{{ person.endDate | date: 'shortDate' }}</td>
                    <td>
                        <div class="progress-container">
                            <p-progressBar [value]="getProgress(person)" [showValue]="false"></p-progressBar>
                            <span style="margin-left: 0.5rem">{{ getProgress(person) }}%</span>
                        </div>
                    </td>
                    <td>
                        <div class="status-indicator" [ngClass]="getProgressClass(getProgress(person))">
                            <i class="pi" [ngClass]="getStatusIcon(getProgress(person))"></i>
                            <span>{{ getStatusText(getProgress(person)) }}</span>
                        </div>
                    </td>
                </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="12" class="text-center">
                        <div class="empty-state">
                            <i class="pi pi-info-circle"></i>
                            <p>No sales person data available</p>
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
    <div class="loading-container" *ngIf="loading">
        <p-progressSpinner></p-progressSpinner>
        <p>Loading User data...</p>
    </div>
</p-card>
